export default "__VITE_ASSET__FwsuX$PV__"